module.exports = __webpack_public_path__ + "img/ch14_11_回村晚霞抱兔.803e42e4.jpg";